<template lang="pug">
.features.address-info.sr-info
  .address-container
    .columns
      .column
        .feature.mb-5
          span Earn passively
        .feature
          p
            .big-number#trx_paid 0.25%
            .feature-helvetica From your referral's mining rewards. Up to 0.5% when applying to our Custom Referral Code program

          div.mt-10
            .field.mt-2.has-text-center
              b Select a coin and enter your address to get your referral code, you don't need to be actively mining!

            .flex.jcc.aic
              .get-referral-container

                .field.coin-dropdown.mt-20
                  .control
                    .dropdown(:class="{'is-active': showDropdown}")
                      .dropdown-trigger(@click="toggleDropdown")
                        button.button.dropdown-button(aria-haspopup="true",aria-controls="dropdown-menu2")
                          span
                            span#search-coin(v-show="!selectedCoin || !selectedCoin.symbol || showDropdown")
                              input#search-coin-input(
                                type="text",
                                placeholder="Type to filter", 
                                ref="inputCoin"
                                v-model="coinFilter"
                                @keyup.enter="selectFirstElement"
                              )
                            span#selected-coin(v-show="selectedCoin && selectedCoin.symbol && !showDropdown")
                              img(:src="selectedCoin.logo",alt="Image")
                              strong {{ selectedCoin.name }} 
                              small {{ selectedCoin.symbol }}
                          span.icon.is-small
                            i.fa.fa-angle-down(aria-hidden="true")

                      .dropdown-menu#dropdown-menu2.bg-white(role="menu")
                        .dropdown-content#dropdown-list

                          .dropdown-item(
                            v-for="o in shadowList"
                            :data-search="o.name + ' ' + o.symbol + ' ' + o.network",
                            :data-symbol="o.symbol",
                            :data-name="o.name",
                            :data-logo="o.logo",
                            @click="selectCoin(o)"
                          this-content)

                            .box
                              article.media
                                .media-left
                                  figure.image.is-24x24
                                    img(:src="o.logo",alt="Image")
                                .media-content
                                  .content
                                    p
                                      strong {{ o.name }} 
                                      small {{ o.symbol }} 
                                    p
                                      span.tag.mr-1.is-light(
                                        v-for="p in o.chains"
                                      ) {{ p.network }}   
                .field.has-addons.flex-1.mt-20.mb-0
                  .control.flex-1
                    input#miningAddress.input.input-address(
                      type="text",
                      placeholder=""
                      v-model="address"
                      :class="{'is-danger': errorAddressMessage}"
                      @keyup.enter="findAddress"
                    )
                  .control#find_address
                    a.button.is-success(@click="findAddress", :disabled="isFindingAddress || disableInput", :class="{'disabled-button': disableInput}")
                      i.fa.fa-search


                div
                  p.help.help-small.notif-danger(v-if="errorAddressMessage") {{ errorAddressMessage }}

                  p.help.info-mining-address-memo(v-if="selectedCoin && selectedCoin.regex_memo")
                    i.fa.fa-info-circle
                    span &nbsp;&nbsp; 
                    u If you are mining to an exchange
                    span  you must set your Memo or Payment Tag after your address, like this: 
                    strong.bg-warning YOUR_ADDRESS:YOUR_PAYMENT_TAG

                  p.help.info-mining-address-XRP(v-if="selectedCoin && selectedCoin.symbol === 'XRP'")
                    i.fa.fa-info-circle
                    span &nbsp;&nbsp; If you’ve just generated your XRP address in your wallet, ensure it is activated by transferring at least 1 XRP to it before your first mining payout.

                .mt-20(v-if="referralCode")
                  .text-white-on-dark 
                    span Your&nbsp;
                    b(v-if="hasCustomCode") Custom&nbsp;
                    span Referral code is:
                  #referral_code.referral-code.hint--right.text-white-on-dark(
                    aria-label='Copy'
                    @click="copyToClipboard(referralCode)"
                  ) {{ referralCode }}
                  div
                  #referral_link.referral-link.hint--right.text-white-on-dark(
                    aria-label='Copy'
                    @click="copyToClipboard(referralLink)"
                  ) {{ referralLink }}
                .mt-20(v-if="referralCode")
                  .is-flex.jcc.aic
                    .button-stats-container
                      a.button.button-stats.is-info(:href="'/address/' + address + '?coin=' + selectedCoin.symbol", target="_blank") 
                        span.mr-5 See your stats
                        i.fa.fa-line-chart

          br
          p.mb-10 Your referral must add your referral code after the worker name (separated by a "#" symbol) and restart the worker!
          .miner-pool 
            span.hint--top.pointable(aria-label='The asset symbol') {{ coin }}
            b :
            span.hint--top.pointable(:aria-label="'Their ' + coin + ' address'") Address
            b .
            span.hint--top.pointable(aria-label='Their worker name!') Worker
            b #
            span.hint--top.pointable.memo-(aria-label='Your Referral code!') {{ referralCode || 'referral-code' }}
          br
          .w400.mb-20 
            span If your setup doesn't accept the 
            span.w600 # 
            span symbol, you can try the alternative syntax, simply replace 
            span.w600 # 
            span with 
            span.w600 ?ref=
          .feature-helvetica.mt-20
            span All mining rewards are paid to your balance, 
            u whether you are mining or not
            span , and if you set a referral code for your own workers you also get rewarded with a lower mining fee.
      .column
        .feature.feature-helvetica
          div
            ul
              li
                .fs-16.mb-15 Your benefits:
              li.ref-code-toggle
                b.fs-13 When you mine  
                .buttons.has-addons
                  button.button.is-small(:class="{'is-selected is-info': !withRefCode}", @click="changeUsingCode(false)") without
                  button.button.is-small(:class="{'is-selected is-info': withRefCode}", @click="changeUsingCode(true)") with
                b.fs-13 a referral code
              li
                p.mt-10(v-if="withRefCode") The platform fee is reduced to 0.75% and you earn 99.25% of your mining rewards.
                p.mt-10(v-else) The platform fee stays at 1% and you earn 99% of your mining rewards.
                referral-image(
                  :withRefCode="withRefCode"
                  :tier="baseTier && baseTier.name ? baseTier : defaultTier"
                  :widthFee="withRefCode ? 15 : null"
                  :widthMiner="withRefCode ? 85 : null"
                )
              li.ref-code-toggle
                b.fs-13 ...if someone else is actively using your referral code
              li
                p.mt-10 
                  span The platform fee is reduced to 0.5% and you earn 0.25% of his rewards, 
                  u  passively
                referral-image(
                  :showDetail="true"
                  :tier="baseTier && baseTier.name ? baseTier : defaultTier"
                  :widthFee="15"
                  :widthMiner="85"
                )
              //- li 
              //-   span Our  
              //-   b 1% 
              //-   span  fee is now dynamically divided in three parts:
              //-   br
              //-   br
              //- li
              //-   span If you give your referral code to other miners you get
              //-   br
              //-   br
              //- li
              //-   b.fs-15 0.25% from all of their mining rewards (*)
              //-   br
              //-   br
              //- li
              //-   span If you setup your workers with another miner's referral code you get
              //-   br
              //-   br
              //- li
              //-   b.fs-15 0.25% fee reduction (0.75% fee down from 1%) (**)
              //-   br
              //-   br
              //- li
              //-   span The last 
              //-   b 0.5% 
              //-   span  of the fee goes to the platform (instead of 1%)  
              //-   b (***)
              //-   br
    .columns#content-creator
      .column
        hr
        .feature.feature-helvetica.has-text-left
          .feature-helvetica.fs-16.has-text-left.mb-18
            b Are you a content creator?   

          //- .articles 
            a.article-mini(href="https://unmineable.com/support/article/benefits-content-creator", target="_blank")
              .article-inner
                .article-title
                  span  Read our article that explains our content creator's special tier of benefits
                span.icon
                  i.fa.fa-external-link

          .columns.is-multiline
            .column.is-one-third
              div.mt-10
                p.fs-16.mb-10 Get an easy to remember referral code to use with your social networks!
                p.fs-14.mb-10 Create content and share your referral code to your followers
                p.fs-14.mb-10 The more miners actively using your code the better rewards you get through our tiers!
            .column.is-two-thirds

              tab-tiers(
                :selectedTab="selectedTier"
                @selected="changeTier"
                @click="changeTier"
                :listOfTabs="tiers"
              )

              div.mt-10.referral-image-container
                referral-image.referral-image-cc(
                  :showDetail="true", 
                  :tier="currentTier && currentTier.name ? currentTier : defaultTier",
                  type="contentCreator"
              )

              div.p-10.mb-30.mt-10.has-text-centered(v-if="currentTier")
                .mb-10(v-if="selectedTier === 0")
                  b.fs-15 The base tier gets you the same rewards as a normal referral code.
                .mb-10(v-else)
                  .fs-15
                    b.has-text-weight-bold(style="color: #66e093;") {{ currentTier.minimum_active }} or more
                    b  active miners using your custom referral code are required
                  .mt-5
                    span You get an aditional 
                    b {{ (+currentTier.owner_percentage - +baseTier.owner_percentage).toFixed(2) }}% 
                    span  on top of the base 0.25% referral rewards.

            .column.is-full
              .fs-14.has-text-weight-bold.mb-10.mt-10 How do I get my Custom Referral Code?

              p
                span Send an email to 
                b support@unmineable.com 
                span with the following information:
              ul.required-info
                li.mb-5 
                  span A brief introduction of yourself and the kind of content that you elaborate
                li.mb-5 
                  span The links to your social network accounts (TikTok, X, Twitch, Instagram, Facebook, etc). Your content doesn't have to be abount mining, as unMineable is a beginner oriented platform, we welcome users from everywhere.
                li.mb-5  
                  span A suggestion of what your referral code should be (Remember that it could only have letters, numbers and a dash (-))
                li.mb-5 
                  span The address and coin where you want to get your rewards! we will link your referral code to this address on the platform.


    .columns
      .column
        .feature.feature-helvetica
          div.has-text-left.fs-13
            hr
            b (*) 
            span  Referral codes are set at a worker level, so to have the best performance all of your referral's workers must be set with a referral code, referral rewards are given every time your referral gets rewarded for mining.
            b (**) 
            span  In the case of the fee reduction there is no need to have all of your workers set with a referral code, you just need one (valid code) set with an active miner for the reduction to be effective.
          br
          br
</template>

<script>
import { apiGet } from '../util/general'
import ReferralImage from '../components/c_referral_image'
import TabTiers from '../components/c_tab_tiers'
export default {
  name: 'view_referral',
  components: {
    'referral-image': ReferralImage,
    TabTiers
  },
  data() {
    return {
      coinFilter: '',
      showDropdown: false,
      isLoadingCoins: false,
      selectedCoin: {},
      errorAddressMessage: '',
      address: '',
      compatibleNetworks: [],
      isFindingAddress: false,
      referralCode: '',
      referralLink: '',
      selectedTier: 0,
      intervalReferralImage: null,
      withRefCode: true,
      intervalReferralUsage: null,
      defaultTier: {
        code: 0,
        name: 'Base Tier',
        minimum_active: '0',
        miner_percentage: '0.15',
        owner_percentage: '0.35',
        platform_percentage: '0.50'
      },
      isLoadingTires: false,
      hasCustomCode: false
    }
  },
  computed: {
    coin() {
      return this.$store.getters.coin
    },
    tiers() {
      return this.$store.getters.tiers
    },
    coins() {
      return this.$store.getters.coins
    },
    shadowList() {
      var vm = this
      if (vm.coins && vm.coins.length > 0) {
        if (vm.coinFilter) {
          return vm.coins.filter(o =>
            o.name.toUpperCase().includes(vm.coinFilter.toUpperCase()) || o.symbol.toUpperCase().includes(vm.coinFilter.toUpperCase()) || o.network.toUpperCase().includes(vm.coinFilter.toUpperCase())
          )
        } else {
          return vm.coins
        }
      }
    },
    disableInput() {
      let vm = this
      if (!vm.address) return true
      if (!vm.selectedCoin && !vm.selectedCoin.symbol) return true
      if (vm.isFindingAddress) return true
      if (vm.errorAddressMessage) return true
      return false
    },
    baseTier() {
      let vm = this
      let baseTire = vm.tiers.find(element => element.code === 0)
      return baseTire
    },
    currentTier() {
      let vm = this
      let tier = vm.tiers.find(element => element.code === vm.selectedTier)
      return tier
    }
  },
  watch: {
    address: function (val) {
      var vm = this
      vm.validateAddress()
      vm.referralCode = ''
    }
  },
  async created() {
    let vm = this
    vm.updateMetaTags()
    vm.$store.dispatch('setPageSelected', 'referral')

    if (!(vm.$store.getters.coins && vm.$store.getters.coins.length > 0)) {
      await vm.$store.dispatch('getCoins')
      vm.isLoadingCoins = false
    } else {
      vm.isLoadingCoins = false
    }

    if (!(vm.$store.getters.tiers && vm.$store.getters.tiers.length > 0)) {
      await vm.$store.dispatch('getTiers')
      vm.isLoadingTiers = false
    } else {
      vm.isLoadingTiers = false
    }
  },
  mounted() {
    let vm = this
    let interval = setInterval(async function () {
      if (vm.coins && vm.coins.length > 0) {
        let selectedCoin = vm.coins.find(element => element.symbol === vm.coin)
        if (selectedCoin && selectedCoin.symbol) {
          vm.selectedCoin = selectedCoin

          vm.address = await vm.$store.dispatch('getLastAddressPerCoin', vm.coin)

          setTimeout(function () {
            vm.findAddress()
          }, 500)
        }
        clearInterval(interval)

        if (vm.$route.hash === '#content-creator') {
          let element = document.getElementById('content-creator')
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
    }, 100)

    vm.intervalReferralImage = setInterval(function () {
      if (vm.selectedTier === 3) vm.selectedTier = 0
      else vm.selectedTier++
    }, 5000)

    vm.intervalReferralUsage = setInterval(function () {
      vm.withRefCode = !vm.withRefCode;
    }, 5000)

    setTimeout(function () {
    }, 100)
  },
  methods: {
    updateMetaTags() {
      let title = 'unMineable Referrals - Earn your favorite crypto coins!'
      document.title = title
      const metaTitle = document.querySelector('head meta[property="og:title"]');
      metaTitle.setAttribute('content', title);
    },
    toggleDropdown() {
      var vm = this
      vm.showDropdown = !vm.showDropdown
      if (vm.showDropdown) {
        vm.$nextTick(() => {
          vm.$refs.inputCoin.focus()
        })
      }
    },
    selectFirstElement() {
      var vm = this
      vm.selectCoin(vm.shadowList[0])
    },
    selectCoin(o) {
      var vm = this
      vm.selectedCoin = o

      vm.filter = ''
      vm.showDropdown = false
      vm.validateAddress()
    },
    validateAddress() {
      var vm = this
      if (vm.address && vm.address.length && vm.selectedCoin && vm.selectedCoin.symbol) {
        let error = false;

        let chains = []
        let chainsNetworkString = []
        let i = 0

        for (i = vm.selectedCoin.chains.length - 1; i >= 0; i--) {
          if (vm.selectedCoin.chains[i].is_default) {
            chains.push(vm.selectedCoin.chains[i])
            chainsNetworkString.push(vm.selectedCoin.chains[i].network)
          }
        }

        for (i = 0; i < vm.selectedCoin.chains.length; i++) {
          if (!vm.selectedCoin.chains[i].is_default) {
            chains.push(vm.selectedCoin.chains[i])
            chainsNetworkString.push(vm.selectedCoin.chains[i].network)
          }
        }

        chainsNetworkString = chainsNetworkString.join(' or ')

        let oneOk = false
        let wrongMessage = ''
        vm.compatibleNetworks = []

        let address = ''
        let memo = ''

        if (vm.selectedCoin.address_prefix) address = vm.address;
        else {
          address = vm.address.split(':')[0];
          memo = vm.address.split(':')[1];
        }

        for (i = 0; i < chains.length; i++) {
          if (!(new RegExp(chains[i].regex)).test(address)) {
            wrongMessage = `Double check your ${vm.selectedCoin.symbol} address, it seems to be invalid! ${vm.selectedCoin.symbol !== chains[i].network ? `It must be a valid ${chainsNetworkString} address, as that's the network(s) we support for this coin.` : ''}`
          } else if (memo && !chains[i].regex_memo) {
            if (chains.length === 1) wrongMessage = `${vm.selectedCoin.symbol} does not support the ADDRESS:MEMO format!`
            else wrongMessage = `This ${vm.selectedCoin.symbol} address on ${chains[i].network} network does not support the ADDRESS:MEMO format!`
          } else {
            vm.compatibleNetworks.push(chains[i].network)

            if (chains[i].regex_memo) {
              if (vm.address.split(':').length === 2 && !(new RegExp(chains[i].regex_memo)).test(memo)) {
                wrongMessage = `Double check your memo value, it seems to be invalid!`
                i = chains.length - 1
                continue
              }
            }
            oneOk = true
          }
        }

        if (!oneOk) {
          error = wrongMessage
        }

        if (error) {
          vm.errorAddressMessage = error
        } else {
          vm.errorAddressMessage = ''
        }
      } else vm.errorAddressMessage = ''
    },
    findAddress() {
      let vm = this
      if (vm.address && !vm.isFindingAddress && !vm.errorAddressMessage) {
        vm.isFindingAddress = true
        vm.address = vm.address.trim()
        let url = '/v5/address/' + vm.address + '?coin=' + vm.selectedCoin.symbol
        var obj = {}
        apiGet(vm, url, obj, function (data) {
          if (data.success) {
            vm.referralCode = data.data.custom_referral_code || data.data.referral_code || ''
            vm.referralLink = window.location.origin + '/?ref=' + vm.referralCode
            vm.hasCustomCode = data.data.has_custom_referral_code
          } else {
            vm.$store.dispatch('notifyError')
          }
        }, function (err) {
          console.error('Error:', err.message)
          vm.$store.dispatch('notifyError')
        }, function () {
          vm.isFindingAddress = false
        })
      }
    },
    copyToClipboard(text) {
      let vm = this
      const clipboardData = event.clipboardData || window.clipboardData || navigator.clipboard;
      clipboardData.writeText(text);
      vm.$store.dispatch('notifySuccess', 'Text copied!')
    },
    changeTier(tier) {
      let vm = this
      vm.selectedTier = tier.code
      clearInterval(vm.intervalReferralImage)
    },
    changeUsingCode(withReferral) {
      let vm = this
      vm.withRefCode = withReferral
      clearInterval(vm.intervalReferralUsage)
    }
  }
}
</script>

<style lang="stylus" scoped>
.big-number
  font-size 45px
html.dark, body.dark
  .feature-helvetica
    color: #fff;
  .articles
    a, span
      color: #fff;
    .article-mini
      .article-inner
        &:hover
          border solid 1px #fff

.mb-18
  margin-bottom 18px

.p-20
  padding 20px
.articles
  .article-mini
    cursor pointer
    color #4a4a4a
    padding 5px 0px
    width 100%
    display block
    .article-inner
      border-radius 5px
      border 1px solid #ccc
      padding: 7px 10px 5px 10px;
      display flex
      align-items center
      &:hover
        border solid 1px #8e8e8e
    .article-title
      flex 1
      span
        font-weight 400
    .article-content
      font-size: 12px;
      text-align: justify;
    .article-bottom
      font-size 13px

.bg-white
  background-color: #fff;
.bg-warning
  background-color: #fef6d8;
  padding 0px 3px

.with-referral
  margin-top 30px

.referral-cc
  display block
  width 400px
  margin-top 10px
  margin-bottom 10px

.get-referral-container
  max-width 300px
  min-width 300px
.coin-dropdown
  margin-bottom 0px

#search-coin 
  input
    border: none;
    padding: 0px;
    margin: 0px;
    outline: none;
    
.dropdown-trigger .button img {
  width: 17px;
  margin-right: 10px;
  vertical-align: middle;
  margin-bottom: 3px;
}
#pasteAddress {
  pointer-events: initial;
  cursor pointer
  display inline-flex
}
.dropdown {
  width: 100%;
}
.dropdown .dropdown-trigger {
  width: 100%;
}
.dropdown .button {
  display: flex;
  width: 100%;
  justify-content: space-between;
  // border-top-right-radius: 0px;
  // border-bottom-right-radius: 0px;
}
.dropdown-menu {
  width: 100%;
  max-height: 300px;
  overflow: auto;
  box-shadow: 0 0.5em 1em -0.125em rgba(10,10,10,.1), 0 0 0 1px rgba(10,10,10,.02);
}
.dropdown-item {
  cursor: pointer;
}
.dropdown-item .box article.media {
  position: relative;
}
.dropdown-item .box article.media .one-network {
  top: 0px;
  position: absolute;
  right: 0px;
}

.mr-1
  margin-right 2px

.coin-dropdown
  min-width 250px

.disabled-button
  background-color #ccc !important

.referral-code
  font-size: 40px;
  font-weight: 500;
  cursor: pointer;
  padding: 10px 0;

.referral-link
  font-size: 11px;
  cursor: pointer;
  font-weight: 400;
  color: gray;

.button-stats-container
  display flex
  justify-content: space-between;
  flex-wrap wrap
  .button-stats
    font-weight 400
    font-size 16px
    font-family: 'Poppins';
    i
      margin-left 5px

ul.required-info
  list-style: inside;
  padding 20px

img.referral-1
  margin-top 10px
  margin-bottom 10px

.tier-container
  width 100%
  display flex
  .tier-option
    padding 20px
    flex 1
    border 1px solid #000
    display flex
    flex-direction column
    justify-content center
    align-items center
    cursor pointer
    &.active
      background-color #ccc

.referral-image-container
  display flex
  justify-content center
  align-items center
  .referral-image-cc
    max-width 350px
    min-width 350px

.tab-content
  text-align: center;
  padding: 0px 5px;
  .up-text
    font-size: 18px;
    font-weight: 400;
  .down-text  
    font-weight: 400;
    font-size: 11px;
.ref-code-toggle
  .buttons, .button
    margin-bottom 0
  .buttons, .fs-13
    display: inline-block;
    vertical-align: middle;
  .fs-13
    margin-left: 5px;
    margin-right: 5px;

.miner-pool
  padding 15px
  font-weight: bold
  border: dashed 2px #efefef;
  font-size: 16px;
  word-break: break-word;
  span
    color:#9e9e9e
  b
    font-family: 'Fredoka one'
    margin: 0px 3px;

@media (max-width: 450px)
  .referral-image-container
    .referral-image-cc
      max-width 325px
      min-width 325px
</style>



// WEBPACK FOOTER //
// View_Referral.vue?2b52ffc6